import { Action } from "@ngrx/store";
import { IDiaprofilPatient } from "../../models/diaprofil-patient";

export const RESET_STATE = "[patient] ResetState";
export const ADD = "[patient] Add";
export const UPDATE = "[patient] Update";
export const DELETE = "[patient] Delete";
export const REPLACE = "[patient] Replace";
export const REPLACE_MULTIPLE = "[patient] Replace multiple";

export interface PatientPayload extends Partial<IDiaprofilPatient> {
  fhirId: string;
}

/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 *
 * See Discriminated Unions: https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
 */
export class ResetStateAction implements Action {
  readonly type = RESET_STATE;
  constructor(public payload?: PatientPayload) {}
}

export class AddAction implements Action {
  readonly type = ADD;
  constructor(public payload: IDiaprofilPatient) {}
}

export class ReplaceAction implements Action {
  readonly type = REPLACE;
  constructor(public payload: IDiaprofilPatient) {}
}

export class ReplaceMultipleAction implements Action {
  readonly type = REPLACE_MULTIPLE;
  constructor(public payload: IDiaprofilPatient[]) {}
}

export class UpdateAction implements Action {
  readonly type = UPDATE;
  constructor(public payload: PatientPayload) {}
}

export class DeleteAction implements Action {
  readonly type = DELETE;
  constructor(public payload: PatientPayload) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
  | ResetStateAction
  | AddAction
  | ReplaceAction
  | ReplaceMultipleAction
  | UpdateAction
  | DeleteAction;



// WEBPACK FOOTER //
// ./src/app/store/actions/patient.actions.ts